export type SetBackupScheduleRequest = {
  period: number;
  day0?: number;
  day1?: number;
  day2?: number;
  day3?: number;
  day4?: number;
  day5?: number;
  day6?: number;
  day: number;
  scheduleBackupType: ScheduleBackupType;
  scheduleBackupDays: number;
  backupDestination: string;
  backupnotifyto: string;
};

export enum ScheduleBackupType {
  FullBackup = 0,
  PartialBackup = 1,
  OnlyPending = 2
}
